export default "__VITE_ASSET__DO9r2FsZ__"